import { Accordion, AccordionDetails, AccordionSummary, Button } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Edit } from '@material-ui/icons';
import moment from 'moment';
import * as React from "react";
import { ICreditsInDTO } from "../../../repository/jago/model/input/ICreditsInDTO";
import { ICardInDTO } from "../../../repository/jago/model/input/ICardInDTO";
import { ICRMSourceEnum } from '../../../repository/jago/model/output/ICRMSourceEnum';
import Utils from '../../../utils/Utils';
import ReduxLanguage from "../../ReduxLanguage";
import Permission from "../../Permission/Permission";
import AbilityProvider from '../../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../../services/PermissionService/PermissionConstants';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column',
    padding: 15,
    backgroundColor: 'white',
  },
  rowActionBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  rowBodyContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowBodyText: {
    fontWeight: 'normal',
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  avatar: {
    color: 'white',
    marginRight: 10,
    backgroundColor: '#0D47A1',
  },
  logo: {
    width: '20%',
  },
  federatedContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 5
  },
  icon: {
    fontSize: 15,
    marginRight: 5,
  },
  accordionDetailsBody: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  actionButton: {
    width: 'fit-content',
    color: 'white',
    marginLeft: 10,
    padding: 4,
    paddingLeft: 10,
    paddingRight: 10,
    fontWeight: 'bold'
  },
  actionButtonText: {
    margin: 0,
    fontWeight: 'bold',
  },
  accordionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  rowBodySectionHeaderText: {
    fontWeight: 'bold'
  }
});

export interface IWalletCreditRowProps extends WithStyles<typeof styles>{
  credit?: ICreditsInDTO;
  onEditCard?: (card: ICardInDTO) => void;
}

class WalletCreditRow extends React.Component<IWalletCreditRowProps, any> {

  public renderBasicCardDetails() {
    const { credit, classes } = this.props;
    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div>
          <h4 style={{ fontWeight: 'bold' }}><ReduxLanguage languageKey="forms.cardCode" /></h4>
          <h4>{credit?.card.code}</h4>
        </div>
        <div>
          <h4 style={{ fontWeight: 'bold' }}><ReduxLanguage languageKey="forms.iseoSalesOrderReference" /></h4>
          <h4>{credit?.card.iseoSalesOrderReference}</h4>
        </div>
        <div>
          <h4 style={{ fontWeight: 'bold' }}><ReduxLanguage languageKey="forms.cardNotes" /></h4>
          <h4>{credit?.card.notes}</h4>
        </div>
      </div>
    );
  }

  public renderAdvancedCardDetails() {
    const { credit, classes } = this.props;
    const card = credit?.card;
    
    let crmLinkComponent = <></>;
    
    if (card?.crmSource === ICRMSourceEnum.SFDC_ISEO) {
      const SFDCCRMLinks = Utils.generateSFDCCRMLink(card.crmId);
      crmLinkComponent = (
        <>
          <a href={SFDCCRMLinks.SFCDLinkBasic} target="_blank" rel="noopener noreferrer">Link Lite</a>
          <br />
          <a href={SFDCCRMLinks.SFCDLinkPremium} target="_blank" rel="noopener noreferrer">Link Standard</a>
        </>
      );
    } else if (card?.crmSource === ICRMSourceEnum.PD_SOFIA) {
      const PDCRMLink = Utils.generateSofiaPDLink(card.crmId);
      crmLinkComponent = (
        <a href={PDCRMLink} target="_blank" rel="noopener noreferrer">Link</a>
      );
    }

    return (
      <div>
        <div style={{ marginBottom: 15, marginLeft: 4 }}>
          <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.cardCode" /></h4>
          <h4 className={classes.rowBodyText}>{card?.code || '---'}</h4>
        </div>
        
        <table width="100%">
          <tr>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.iseoSalesOrderReference" /></h4>
              <h4 className={classes.rowBodyText}>{card?.iseoSalesOrderReference || '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.iseoSalesOrderDate" /></h4>
              <h4 className={classes.rowBodyText}>{card?.iseoSalesOrderDate ? moment(card.iseoSalesOrderDate).format('L') : '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.iseoPurchaseOrderReference" /></h4>
              <h4 className={classes.rowBodyText}>{card?.iseoPurchaseOrderReference || '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.iseoPurchaseOrderDate" /></h4>
              <h4 className={classes.rowBodyText}>{card?.iseoPurchaseOrderDate ? moment(card.iseoPurchaseOrderDate).format('L') : '---'}</h4>
            </td>
          </tr>
          <tr>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.sofiaSalesOrderReference" /></h4>
              <h4 className={classes.rowBodyText}>{card?.sofiaSalesOrderReference || '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.sofiaSalesOrderDate" /></h4>
              <h4 className={classes.rowBodyText}>{card?.sofiaSalesOrderDate ? moment(card.sofiaSalesOrderDate).format('L') : '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.crmSource" /></h4>
              <h4 className={classes.rowBodyText}>{card?.crmSource || '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.crmId" /></h4>
              <h4 className={classes.rowBodyText}>{card?.crmId || '---'}</h4>
            </td>
          </tr>
          <tr>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.sofiaProjectId" /></h4>
              <h4 className={classes.rowBodyText}>{card?.sofiaProjectId || '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.kamReference" /></h4>
              <h4 className={classes.rowBodyText}>{card?.kamReference || '---'}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.crmLink" /></h4>
              <h4 className={classes.rowBodyText}>{crmLinkComponent}</h4>
            </td>
            <td>
              <h4 className={classes.rowBodySectionHeaderText}><ReduxLanguage languageKey="forms.cardNotes" /></h4>
              <h4 className={classes.rowBodyText}>{card?.notes || '---'}</h4>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
    );
  }

  public render() {
    const { credit, classes, onEditCard } = this.props;
    const canSeeCardsDetails = AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.NAVIGATION_CARDS);

    return (
      <div className={classes.rowContainer}>
        <div className={classes.rowHeader}>
          <h3 className={classes.rowTitle}>{<ReduxLanguage languageKey="credits.rechargeRowTitle" />}</h3>
          <h4 className={classes.rowBodyText} style={{ marginLeft: 3 }}>{moment(credit?.createdAt).format('LL')}</h4>
        </div>
        <div className={classes.rowBodyContainer}>
          <h4 className={classes.rowBodyText} style={{ marginLeft: 3 }}>{<ReduxLanguage languageKey="credits.rechargeCreditsDescription" languageProps={{ credits: Utils.formatCreditsIn(credit?.quantity) }}/>}</h4>
        </div>
        {credit && credit.card ? (
          <Accordion style={{ marginTop: 10, zIndex: 20 }} elevation={1}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={classes.accordionHeader}>
                <h4 className={classes.rowBodyText} style={{ margin: 0 }}><ReduxLanguage languageKey="credits.rechargeCardDetails" /></h4>
                <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.CARD_UPDATE}>
                  {onEditCard && (
                    <Button
                      variant="contained"
                      className={classes.actionButton}
                      style={{ backgroundColor: 'green', margin: 0 }}
                      onClick={(e) => { e.stopPropagation(); onEditCard(credit.card); }}
                    >
                      <Edit className={classes.icon} />
                      <h5 className={classes.actionButtonText}><ReduxLanguage languageKey="forms.edit" /></h5>
                    </Button>
                  )}
                </Permission>
              </div>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetailsBody}>
              {canSeeCardsDetails ? this.renderAdvancedCardDetails() : this.renderBasicCardDetails()}
            </AccordionDetails>
          </Accordion>
        ) : null}
      </div>
    );
  }
}

export default withStyles(styles)(WalletCreditRow);